var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.outerStyle),attrs:{"id":"rh-header-slot"}},[_c('ClickableBreadcrumbs',{staticClass:"desktop",attrs:{"id":"breadcrumbs-container"}}),_c('TTReader',{attrs:{"id":"header-story","hide-if-empty":"","panel":_vm.panel,"data-cy":"header-panel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }